export const EXHIBITION = 0
export const HIGHLIGHT = 1
export const THEME = 2
